enum BlogPostStatus {
  None,
  Draft,
  Published
}

export default BlogPostStatus